function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "CHANGES-APPLIED",
  transform: "translate(-189.000000, -474.000000)",
  fill: "#C4CDD6",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(80.000000, 411.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(0.000000, 34.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M118.266378,29.0146269 C117.832751,28.9425959 117.414592,29.1421005 117.249126,29.4920129 L109.067473,46.9090704 C108.95293,47.1529218 108.985656,47.4308032 109.154744,47.6500876 C109.322936,47.8685927 109.606567,48 109.909288,48 L118.090942,48 C118.59275,48 119,47.6461168 119,47.2083274 L119,29.7912698 C119,29.4128568 118.692762,29.0874743 118.266378,29.0146269 Z",
  id: "Path"
})))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(14)"
}, /*#__PURE__*/React.createElement("g", {
  id: "CHANGES-APPLIED",
  transform: "translate(-203.000000, -474.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(80.000000, 411.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(0.000000, 34.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M132.932527,46.9090848 L124.750874,29.4922566 C124.586346,29.1423488 124.167249,28.9420304 123.733622,29.0148768 C123.307281,29.0877233 123,29.4131015 123,29.7915096 L123,47.2083378 C123,47.6461215 123.406355,48 123.909058,48 L132.090712,48 C132.393433,48 132.677064,47.8685944 132.845256,47.6500922 C133.014344,47.4307736 133.04707,47.1528958 132.932527,46.9090848 Z",
  id: "Path"
})))));

var SvgActiveVflip = function SvgActiveVflip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    transform: "translate(1, -3) rotate(-90)",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActiveVflip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ActiveVflip.58165a2c.svg";
export { ForwardRef as ReactComponent };